// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInCreateNewAccountStyles } from "@steiner/Overrides/Widgets/SignIn/SignInCreateNewAccount";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem = {
    width: 12,
    css: css`
        justify-content: space-between;
        ${xScreen("lte", "md")} {
            gap: 20px;
            flex-wrap: wrap;
            justify-content: flex-start;
        }
    `,
};

signInCreateNewAccountStyles.createNewAccountButton = {
    variant: "secondary",
};

signInCreateNewAccountStyles.checkoutAsGuestButton = {
    variant: "primary",
};

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    variant: "h2",
    as: "h2",
    css: css`
        margin-bottom: 0;
    `,
};
